/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseReportItem
 */
export interface ResponseReportItem {
    /**
     * 
     * @type {number}
     * @memberof ResponseReportItem
     */
    actualShippingNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseReportItem
     */
    arriveNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    arrivedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    asin?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    baseName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseReportItem
     */
    destructionNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    expiryDate?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    fnsku?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    itemName?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    jan?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    planName?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseReportItem
     */
    returnNum?: number;
    /**
     * 
     * @type {number}
     * @memberof ResponseReportItem
     */
    setNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    shippedDate?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseReportItem
     */
    shippingNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    sku?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseReportItem
     */
    stickerNum?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseReportItem
     */
    userName?: string;
}

/**
 * Check if a given object implements the ResponseReportItem interface.
 */
export function instanceOfResponseReportItem(value: object): value is ResponseReportItem {
    return true;
}

export function ResponseReportItemFromJSON(json: any): ResponseReportItem {
    return ResponseReportItemFromJSONTyped(json, false);
}

export function ResponseReportItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseReportItem {
    if (json == null) {
        return json;
    }
    return {
        
        'actualShippingNum': json['actual_shipping_num'] == null ? undefined : json['actual_shipping_num'],
        'arriveNum': json['arrive_num'] == null ? undefined : json['arrive_num'],
        'arrivedDate': json['arrived_date'] == null ? undefined : json['arrived_date'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'baseName': json['base_name'] == null ? undefined : json['base_name'],
        'destructionNum': json['destruction_num'] == null ? undefined : json['destruction_num'],
        'expiryDate': json['expiry_date'] == null ? undefined : json['expiry_date'],
        'fnsku': json['fnsku'] == null ? undefined : json['fnsku'],
        'itemName': json['item_name'] == null ? undefined : json['item_name'],
        'jan': json['jan'] == null ? undefined : json['jan'],
        'memo': json['memo'] == null ? undefined : json['memo'],
        'planName': json['plan_name'] == null ? undefined : json['plan_name'],
        'returnNum': json['return_num'] == null ? undefined : json['return_num'],
        'setNum': json['set_num'] == null ? undefined : json['set_num'],
        'shippedDate': json['shipped_date'] == null ? undefined : json['shipped_date'],
        'shippingNum': json['shipping_num'] == null ? undefined : json['shipping_num'],
        'sku': json['sku'] == null ? undefined : json['sku'],
        'status': json['status'] == null ? undefined : json['status'],
        'stickerNum': json['sticker_num'] == null ? undefined : json['sticker_num'],
        'userName': json['user_name'] == null ? undefined : json['user_name'],
    };
}

export function ResponseReportItemToJSON(json: any): ResponseReportItem {
    return ResponseReportItemToJSONTyped(json, false);
}

export function ResponseReportItemToJSONTyped(value?: ResponseReportItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actual_shipping_num': value['actualShippingNum'],
        'arrive_num': value['arriveNum'],
        'arrived_date': value['arrivedDate'],
        'asin': value['asin'],
        'base_name': value['baseName'],
        'destruction_num': value['destructionNum'],
        'expiry_date': value['expiryDate'],
        'fnsku': value['fnsku'],
        'item_name': value['itemName'],
        'jan': value['jan'],
        'memo': value['memo'],
        'plan_name': value['planName'],
        'return_num': value['returnNum'],
        'set_num': value['setNum'],
        'shipped_date': value['shippedDate'],
        'shipping_num': value['shippingNum'],
        'sku': value['sku'],
        'status': value['status'],
        'sticker_num': value['stickerNum'],
        'user_name': value['userName'],
    };
}

